import styled from "@emotion/styled";

import { H2Container, H3Container } from "shared/components/content/content-summary/styles";
import { fontMerriweather, fontRoboto, fontRobotoCondensed, theme } from "shared/lib/styles";

import { FlexContainer as ContentActionBar } from "scmp-app/components/content/content-action-bar/styles";
import { Flag } from "scmp-app/components/content/content-headline/content-headline-tag/styles";
import {
  Headline as ContentHeadline,
  SponsorHeadline,
} from "scmp-app/components/content/content-headline/styles";
import { StyledTopicLink } from "scmp-app/components/content/content-topic-link/styles";

export const Container = styled.div`
  display: flex;
  flex-wrap: nowrap;

  margin-block-end: 32px;

  ${theme.breakpoints.up("tablet")} {
    margin-block-end: 24px;
    padding-block-end: 24px;
    border-block-end: 1px solid #e9e9e9;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column-reverse;

  ${theme.breakpoints.up("tablet")} {
    flex: 1;
    flex-direction: row;
  }
`;

export const ContentWrapper = styled.div`
  flex: 1;

  ${theme.breakpoints.up("tablet")} {
    margin-block-end: 0;
    margin-inline-end: 24px;
  }
`;

export const Headline = styled.div`
  margin-block-end: 12px;
  ${ContentHeadline}, ${SponsorHeadline} {
    color: #000000;
  }
  ${ContentHeadline}, ${SponsorHeadline}, ${Flag} {
    font-weight: 700;
    font-size: 16px;
    font-family: ${fontMerriweather};
    line-height: 140%;
    ${theme.breakpoints.up("tablet")} {
      font-size: 18px;
    }
  }
`;

export const Summary = styled.div`
  ${H2Container}, ${H3Container} {
    display: none;

    ${theme.breakpoints.up("tablet")} {
      display: block;

      margin-block-end: 12px;

      color: #666666;
      font-size: 14px;
      font-family: ${fontRoboto};
      line-height: 130%;
    }
  }
`;

export const ActionBar = styled.div`
  ${ContentActionBar} {
    time {
      color: #999999;
      font-size: 12px;
      line-height: 14px;
    }
  }
`;

export const CoverContainer = styled.div`
  margin-block-end: 20px;

  border-radius: 8px;

  overflow: hidden;

  figure {
    aspect-ratio: 335 / 223.33;
    ${theme.breakpoints.up("tablet")} {
      aspect-ratio: 260 / 173.33;
    }
  }

  ${theme.breakpoints.up("tablet")} {
    inline-size: 260px;
    block-size: 173.33px;
    margin-block-end: 0;
  }
`;

export const TopicLink = styled.div`
  ${StyledTopicLink} {
    margin-block-end: 8px;

    color: #000000;
    font-weight: 700;
    font-size: 14px;
    font-family: ${fontRobotoCondensed};
    line-height: 100%;
  }
`;
